var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { useMobxForm } from 'ziphy-web-shared/basic/lib/forms';
import { Textarea } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $loader } from 'ziphy-web-shared/basic/utils';
import SignModal from '../../ui/signModal/Sign.modal';
import sectionStyles from '../Section.module.scss';
import styles from './SectionAddAddendum.module.scss';
const SectionAddAddendum = () => {
    const { t } = useTranslation();
    const form = useMobxForm(useMemo(() => ({
        initialValues: { addendumText: '' },
        fieldsConfig: { addendumText: { validate: ['required'] } },
    }), []));
    const addendumText = form.field('addendumText', '');
    const handleSubmit = form.submit((data) => __awaiter(void 0, void 0, void 0, function* () {
        $modal.add(SignModal, {
            addendumText: data.addendumText,
            onAfterSubmit: () => __awaiter(void 0, void 0, void 0, function* () { return addendumText.reset(); }),
        });
    }));
    return (_jsxs("div", Object.assign({ className: sectionStyles.wrapper }, { children: [_jsxs("div", Object.assign({ className: sectionStyles.body }, { children: [_jsx("div", Object.assign({ className: sectionStyles.title }, { children: _jsx(Title, Object.assign({ size: 'h2' }, { children: t('label.add_addendum') })) })), _jsx("div", Object.assign({ className: styles.block }, { children: _jsx("form", Object.assign({ id: form.id, onSubmit: $loader.registerHandler(form.id, handleSubmit) }, { children: _jsx(Textarea, { field: addendumText, placeholder: t('label.text_something'), mode: ['transparent'], rows: 1 }) })) }))] })), addendumText.isTouched && (_jsx("div", Object.assign({ className: classNames(sectionStyles.footer, styles.footer) }, { children: _jsxs("div", Object.assign({ className: styles.buttons }, { children: [_jsx(Button, Object.assign({ mode: ['secondary', 'sm', 'min110'], onClick: () => addendumText.reset() }, { children: t('btn.cancel') })), _jsx(Button, Object.assign({ mode: ['primary', 'sm'], form: form.id, disabled: addendumText.isInvalid }, { children: t('btn.sign_addendum') }))] })) })))] })));
};
export default observer(SectionAddAddendum);
